import React from 'react'
import utils from './utils'

function getLevelLayout(width, height, settings, quantities, answer, onEnter) {
    return getLayout(width, height, settings, quantities, answer)
}

function getLayout(width, height, settings, quantities, answer) {
    const {
        gameContainerWidth,
        gameContainerHeight,
        marginBottom,
        lineWeight,
        gridCount,
        cellSize,
        sideMargin,
        fontSize,
    } = getLayoutSettings(width, height)

    let tens = Math.floor(quantities.value_1 / 10)
    let units = quantities.value_1 % 10
    let tens2 = Math.floor(quantities.value_2 / 10)
    let units2 = quantities.value_2 % 10

    let boardHeight = gameContainerHeight / 1.5
    let size = boardHeight / 5
    let baseY = gameContainerHeight / 2 + boardHeight / 2
    let val1Width = settings.answer_required !== 'value_1' ? size * (tens * 3 + (units ? 3 : 0) - 1) : fontSize / 1.5
    let val12Width = settings.answer_required !== 'value_2' ? size * (tens2 * 3 + (units2 ? 3 : 0) - 1) : fontSize / 1.5
    let baseWidth = val1Width + (!quantities.value_2 ? 0 : fontSize + val12Width)
    let baseX = sideMargin
    let baseX2 = baseX + val1Width + fontSize * 1.5
    let boards1 = quantities.value_1 ? utils.getBoards(quantities.value_1, baseX, baseY, boardHeight, 'red') : []
    let boards2 = quantities.value_2 ? utils.getBoards(quantities.value_2, baseX2, baseY, boardHeight, 'green') : []

    if (settings.answer_required !== 'answer') {
        baseWidth += fontSize * 2
    }
    let widthScale = gameContainerWidth * 0.9 > baseWidth ? 1 : gameContainerWidth * 0.9 / baseWidth

    return (
        <svg
            height={gameContainerHeight}
            width={gameContainerWidth}

        >
            <g transform={`translate(${gameContainerWidth / 2 - baseWidth * widthScale / 2}, ${(gameContainerHeight - gameContainerHeight * widthScale) / 2}) scale(${widthScale})`}>
                {settings.answer_required !== 'value_1' ? boards1.map(value => {
                    return value
                }) :
                    utils.getOperationSign(
                        baseX + fontSize / 2,
                        gameContainerHeight / 2,
                        fontSize / 1.5,
                        'answer'
                    )
                }

                {settings.answer_required !== 'value_2' ? boards2.map(value => {
                    return value
                }) :
                    utils.getOperationSign(
                        baseX2 + fontSize / 3,
                        gameContainerHeight / 2,
                        fontSize / 1.5,
                        'answer'
                    )
                }

                {quantities.value_2 && !isNaN(quantities.value_2) ? utils.getOperationSign(
                    baseX2 - fontSize / 1.3,
                    gameContainerHeight / 2,
                    fontSize / 1.5,
                    settings.operation === 'addition' ? 'plus' : 'minus'
                ) : null}


                {settings.answer_required !== 'answer' && utils.getOperationSign(
                    baseX2 + val12Width + fontSize / 1.5,
                    gameContainerHeight / 2,
                    fontSize / 1.5,
                    'equal'
                )}

                {settings.answer_required !== 'answer' && <text
                    className="level-text-primary"
                    fontSize={fontSize}
                    fontWeight="regular"
                    dominantBaseline="middle"
                    x={baseX2 + val12Width + fontSize + fontSize / 3}
                    y={gameContainerHeight / 2}
                    textAnchor="start"
                >{`${ settings.operation === 'addition' ? +quantities.value_1 + +quantities.value_2 : +quantities.value_1 - +quantities.value_2}`}</text>
                }
            </g>
        </svg>
    )
}

function getLayoutSettings(gameContainerWidth, gameContainerHeight) {
    /* const gameContainerMargin = gameContainerWidth * .04

    if (gameContainerWidth * 0.6 > gameContainerHeight) {
        gameContainerWidth = gameContainerHeight / 0.6 - gameContainerMargin
        gameContainerHeight = gameContainerHeight - gameContainerMargin
    } else {
        gameContainerWidth = gameContainerWidth - gameContainerMargin
        gameContainerHeight = gameContainerWidth * 0.6 - gameContainerMargin
    } */

    const lineWeight = gameContainerWidth / 130
    const marginBottom = gameContainerHeight / 40
    const gridCount = 10
    const cellSize = (gameContainerHeight - marginBottom) / gridCount - lineWeight / gridCount
    const sideMargin = 0//gameContainerWidth * .05
    const fontSize = gameContainerWidth / 9
    return {
        gameContainerWidth,
        gameContainerHeight,
        marginBottom,
        lineWeight,
        gridCount,
        cellSize,
        sideMargin,
        fontSize,
    }
}

export default {
    getLevelLayout,
}


// WEBPACK FOOTER //
// ./src/components/game/levels/utils/tenBoards.utils.js